import type {
  ClientType,
  DpopMode,
  SwapTokenType,
} from '@lseg-ciam/auth/login';
import { createRetryFetch$, flog } from '@lseg-ciam/auth/utils';
import { MonoTypeOperatorFunction, tap } from 'rxjs';
import { AppConfig, isNextPathValid } from './config.js';

// Re-export from SDK
export { finalizeLogin } from '@lseg-ciam/auth/login';

export type BaseConfig = {
  idpKey: string;
  clientUid: string;
  clientId: string;
  nextPath: string;
};

export type OpenIdConfig = {
  authorization_endpoint: string;
  token_endpoint: string;
  scopes_supported: string[];
  end_session_endpoint?: string;
  frontchannel_logout_supported?: boolean;
  frontchannel_logout_uri?: string;
};

export type TokenSwapOpenIdConfig = OpenIdConfig & {
  idps: Record<string, IdpContext>;
  token_endpoint?: string;
  client_type: ClientType;
  dpop?: DpopMode;
};

export type IdpContext = {
  well_known: string;
  client_id: string;
  scopes_required?: string;
  swap?: SwapTokenType;
};

function createWellKnownUrl(issuerUrl: string, clientUid: string) {
  return `${wellKnownUrlFromIssuer(issuerUrl)}?${clientUid}`;
}

function wellKnownUrlFromIssuer(issuerUrl: string) {
  return `${issuerUrl}/.well-known/openid-configuration`;
}

export function createIssuerConfig$(issuerUrl: string, clientUid: string) {
  return createRetryFetch$<TokenSwapOpenIdConfig>(
    createWellKnownUrl(issuerUrl, clientUid),
    { addHeimdallTrace: true, syncToDateHeader: true }
  ).pipe(flog('Issuer Config'));
}

export function validateRedirectionPaths(): MonoTypeOperatorFunction<AppConfig> {
  return tap((config) => {
    if (config.recoverPath && !isNextPathValid(config.recoverPath)) {
      throw new Error(`Invalid recover path ${config.recoverPath}`);
    }

    if (!isNextPathValid(config.nextPath)) {
      throw new Error(`Invalid next path ${config.nextPath}`);
    }
  });
}
